import { ReportType } from 'reporting/types';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

interface ReportTypeState {
    reportType: ReportType;
    setReportType: (reportType: ReportType) => void;
}

export const useReportTypeStore = create<ReportTypeState>()(
    persist(
        immer((set) => ({
            reportType: undefined,

            setReportType: (reportType: ReportType) =>
                set((state: { reportType: ReportType }) => {
                    state.reportType = reportType;
                }),
        })),
        {
            name: 'report-type',
            storage: createJSONStorage(() => sessionStorage),
        },
    ),
);
